import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';
import ProfileViewOne from '@/themes/themeOne/profile/profileView.vue';
import ProfileViewTwo from '@/themes/themeTwo/profile/profileView.vue';
import ProfileViewThree from '@/themes/themeThree/profile/profileView.vue';
import { ProfileSettingData } from './supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'profileView',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()
const themeStore = useThemeStore()
const nickName = computed(() => userStore.nickname)
const loginAccount = computed(() => userStore.loginAccount)
const avatarImg = computed(() => userStore.headimg)

const dataSet = computed<ProfileSettingData>(() => ({
    nickName: nickName.value,
    loginAccount: loginAccount.value,
    avatarImg: avatarImg.value
}))

const goToPath = (path : string) => {
    router.push(path)
}

onMounted(() => {
    userStore.getInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ProfileViewOne, {
            "data-set": dataSet.value,
            onGoToPath: goToPath
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ProfileViewTwo, {
            "data-set": dataSet.value,
            onGoToPath: goToPath
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(ProfileViewThree, {
            "data-set": dataSet.value,
            onGoToPath: goToPath
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})